import { RouteConfig } from 'vue-router'

const FamousTeacherList = () => import('@/views/famous-teacher-lecture/List.vue')
const FamousTeacherDetail = () => import('@/views/famous-teacher-lecture/Detail.vue')
const FamousTeacherShare = () => import('@/views/famous-teacher-lecture/Share.vue')
const Advance = () => import('@/views/famous-teacher-lecture/Advance.vue')

export const famousTeacherListRouter: RouteConfig = {
  path: '/famous-teacher-list',
  name: 'famous_teacher_list',
  component: FamousTeacherList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '名师讲堂',
    ignoreLogin: true,
  },
}

export const famousTeacherDetailRouter: RouteConfig = {
  path: '/famous-teacher-detail',
  name: 'famous_teacher_detail',
  component: FamousTeacherDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程详情',
    // ignoreLogin: true,
  },
}

export const famousTeacherShareRouter: RouteConfig = {
  path: '/famous-teacher-share',
  name: 'famous_teacher_share',
  component: FamousTeacherShare,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分享课程',
  },
}

export const advanceRouter: RouteConfig = {
  path: '/famous-teacher-advance',
  name: 'famous_teacher_advance',
  component: Advance,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '研修班',
  },
}

export default [famousTeacherListRouter, famousTeacherDetailRouter, famousTeacherShareRouter, advanceRouter]
